var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MdFileUpload } from 'react-icons/md';
import styled from 'styled-components';
import { Icon, Flex, Spinner, buttonCss } from "./..";
import { FileUploadInput } from './FileUploadInput';
var Wrapper = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  display: flex;\n"], ["\n  ", ";\n  display: flex;\n"])), buttonCss);
export var FileUploadButton = function (_a) {
    var onFileSelection = _a.onFileSelection, _b = _a.isUploading, isUploading = _b === void 0 ? false : _b, id = _a.id, _c = _a.selectLabel, selectLabel = _c === void 0 ? 'Upload CSV' : _c, acceptedFileTypes = _a.acceptedFileTypes, _d = _a.palette, palette = _d === void 0 ? 'primary' : _d, _e = _a.emphasis, emphasis = _e === void 0 ? 'medium' : _e, _f = _a.scale, scale = _f === void 0 ? 'md' : _f, _g = _a.lss, lss = _g === void 0 ? {} : _g, _h = _a.iconProps, iconProps = _h === void 0 ? {} : _h;
    return (React.createElement(FileUploadInput, { id: id, accept: acceptedFileTypes, onFileSelection: onFileSelection, lss: { p: 0 }, label: React.createElement(Wrapper, { palette: palette, emphasis: emphasis, scale: scale, lss: __assign({ alignItems: 'center', justifyContent: 'center', width: 200 }, lss) }, isUploading ? (React.createElement(Spinner, { size: "sm" })) : (React.createElement(React.Fragment, null,
            React.createElement(Icon, __assign({ as: MdFileUpload, size: 20 }, iconProps, { lss: __assign({ color: 'secondary500', mr: 'xs' }, iconProps.lss) })),
            selectLabel))) }));
};
var templateObject_1;
//# sourceMappingURL=FileUploadButton.js.map